@if (this.subscriptionCount > 1) {
  <div class="grid-1">
    <app-subscription-selector (selectedSubscriptionChanged)="this.selectedSubscriptionChanged($event);"/>
  </div>
}

<div class="grid-desktop-3 grid-tablet-1 grid-mobile-1 root-container subscription-container">
  @if (this.selectedSubscription && this.selectedSubscription.products.length > 0) {
    <app-card [fullHeight]='false' header="Mijn abonnement">
      @for (productType of this.getProductTypes(); track productType) {
        @if (this.getProductForTypes(productType).length > 0) {
          <app-badge-with-content icon="{{this.typeToIconAndTitle[productType].icon}}" size="small" type="regular"
            header="{{this.typeToIconAndTitle[productType].title}}" [center]="true">
          </app-badge-with-content>
          <ul>
            @for (product of this.getProductForTypes(productType); track product) {
              <li class="product_line">
                <div>
                  {{ product.specs.title }}
                  @if (product.date_ophef && product.state === ProductState.ACTIVE) {
                    <span class="termination-date">
                      <app-icon icon="clock"></app-icon>
                      <span>Eindigt op: {{ product.date_ophef | date: 'dd-MM-yyyy' }}</span>
                    </span>
                  }
                  @if (product.is_terminateable) {
                    <app-button ariaLabel="{{product.specs.title}}} opzeggen" type="icon-only"
                      icon="trash"
                      iconType="solid"
                      actionType="delete"
                      (click)="this.terminate(product)"
                      onKeyUp="">
                    </app-button>
                  }
                  @if (hasDetails(product) && product.product_type === ProductType.TELEVISION) {
                    <app-button ariaLabel="Bekijk tv app login"
                      class="info-icon"
                      type="icon-only"
                      icon="circle-info"
                      iconType="solid"
                      (click)="this.showTelevisionDetailsModal(product)"
                      onKeyUp="">
                      <span ngProjectAs="[iconText]">Bekijk tv app login</span>
                    </app-button>
                  }
                  @if (hasDetails(product) && product.product_type === ProductType.PHONE) {
                    <app-button ariaLabel="Bekijk belhistorie"
                      class="info-icon"
                      type="icon-only"
                      icon="circle-info"
                      iconType="solid"
                      (click)="this.showPhoneDetailsModal(product)"
                      onKeyUp="">
                      <span ngProjectAs="[iconText]">Bekijk belhistorie</span>
                    </app-button>
                  }
                </div>
                <app-currency [value]="product.original_price"/>
                <ul>
                  @for (line of product.discount_lines; track line) {
                    <li class="discount_line">
                      <div>
                        {{ line.description }}
                        @if (this.activeRelation?.is_business) {
                          <app-currency [value]="line.amount_excl"/>
                        }
                        @if (!this.activeRelation?.is_business) {
                          <app-currency [value]="line.amount_incl"/>
                        }
                        @if (line.date_end) {
                          <div>Einddatum:
                            <span class="date">{{ line.date_end | date: 'dd-MM-yyyy' }}</span>
                          </div>
                        }
                      </div>
                    </li>
                  }
                </ul>
              </li>
            }
          </ul>
          @if (this.getProductForTypes(productType).length > 0) {
            <app-divider></app-divider>
          }
        }
      }
      <div class="total">
        <div class="text-heading">Totale prijs</div>
        <app-currency [value]="this.getSelectedTotalPrice()"/>
        @if (this.activeRelation?.is_business) {
          <div>Prijs exclusief BTW.</div>
        }
        @if (!this.activeRelation?.is_business) {
          <div>Prijs inclusief BTW.</div>
        }
      </div>
    </app-card>
  } @else {
    <app-card header="Mijn abonnement">
      <app-not-found header="Geen producten gevonden">
        <span>Er zijn geen actieve producten gevonden in dit abonnement.</span>
      </app-not-found>
    </app-card>
  }

  <app-contract-information [subscription]="this.selectedSubscription"/>
</div>
